<template>
  <div class="container">
    <div class="row">
      <div class="col-md-3 mb-4 mb-md-0 cms-page--sidebar">
        <h3 class="title">{{ $t("information") }}</h3>
        <ul class="list-unstyled cms-page--sidebar__nav">
          <li>
            <a href="#" class="active">{{ $t("frequentlyAskedQuestions") }}</a>
          </li>
        </ul>
      </div>

      <div class="col-md-9 cms-page__content">
        <h1
          class="title"
        >
          {{ $t("wonder") }}
        </h1>
        <form id="searchform" method="get" action="#/" class="search-container">
          <div class="form-group" style="position: relative">
            <input
              type="text"
              class="form-control"
              :placeholder="$t('placeholderSearch')"
              name="s"
              v-model.trim="searchQuery"
              style="padding-left: 50px"
            /><button
              type="submit"
              class="btn btn-primary"
              style="position: absolute; right: 0; top: 0"
            >
              {{ $t("searchs") }}
            </button>
          </div>
        </form>
        <small >{{ $t("suggestive") }} </small>

        <div class="tab-content pt-1" id="faq-tab-content">
          <div
            class="tab-pane fade show active"
            id="chuhang-faq"
            role="tabpanel"
            aria-labelledby="chuhang-tab"
          >
            <div class="accordion" id="chuhang-accordion" v-show="resources">
              <div class="card" v-for="item in resultQuery" :key="item.id"   @click="item.isExpanded = !item.isExpanded">
                <div class="card-header" id="headingCollapse1 ">
                  <h5 v-bind:href="item.uri" target="_blank" class="w-100">
                    <button
                      class="btn btn-link pl-0"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapse1"
                      aria-expanded="true"
                      aria-controls="collapse1"
                      style="color: #2b938c"
                    >
                      {{ item.title }}
                    </button>
                  </h5>
                   <b-icon icon="chevron-down"></b-icon>
                </div>
                <div
                  id="collap`s`e1"
                  class="close-card"
                  aria-labelledby="collapse1"
                  data-parent="#accordion1"
                  v-if="item.isExpanded"
                >
                  <div class="activecard-body pt-0">
                    <p>
                      {{ item.body }}
                      <!-- <a href="https://www.logivan.com/chu-hang/">đây</a> để xem
                      chi tiết -->
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";

/* eslint-disable global-require */
import axios from "axios";
export default {
  name: "Faq",
  components: {
    BRow,
    BCol,
  },

  data() {
    return {
      searchQuery: null,
      resources: [],
    };
  },
  mounted() {
   this.resources = [
           
            {
              title: this.$i18n.t("titleFaq1"),
              body: this.$i18n.t("bodyFaq1"),
              icon: null,
              isExpanded: false,
            },
            {
              title: this.$i18n.t("titleFaq2"),
              body: this.$i18n.t("bodyFaq2"),
              icon: null,
              isExpanded: false,
            },
            {
              title: this.$i18n.t("titleFaq3"),
              body: this.$i18n.t("bodyFaq3"),
              icon: null,
              isExpanded: false,
            },
            ]
  },
   watch: {
    "$i18n.locale": function () {
        this.resources = [{
              title: this.$i18n.t("titleFaq1"),
              body: this.$i18n.t("bodyFaq1"),
              icon: null,
              isExpanded: false,
            },
            {
              title: this.$i18n.t("titleFaq2"),
              body: this.$i18n.t("bodyFaq2"),
              icon: null,
              isExpanded: false,
            },
            {
              title: this.$i18n.t("titleFaq3"),
              body: this.$i18n.t("bodyFaq3"),
              icon: null,
              isExpanded: false,
            },]
      
    },
  },
  computed: {
    resultQuery() {
      if (this.searchQuery) {
        return this.resources.filter((item) => {
          return this.searchQuery
            .toLowerCase()
            .split(" ")
            .every((v) => item.title.toLowerCase().includes(v));
        });
      } else {
        return this.resources;
      }
    },
  },
 
};

</script>



 <style lang="scss" scoped>
@import "@core/scss/vue/pages/faq.scss";
</style>
